import { BRANDS } from "../lib/site";

export const BrandMarquee = () => {
  const items = [...BRANDS, ...BRANDS];
  return (
    <div data-testid="brand-marquee" className="border-y border-white/10 bg-[#0A0A0A] overflow-hidden">
      <div className="flex animate-marquee whitespace-nowrap py-10">
        {items.map((b, i) => {
          const Icon = b.icon;
          return (
            <div key={`${b.key}-${i}`} className="flex items-center gap-4 px-12 shrink-0">
              <Icon className="w-12 h-12 md:w-16 md:h-16 text-white/40 hover:text-white transition-colors" />
              <span className="font-display font-black uppercase text-2xl md:text-3xl text-white/30 tracking-tight">
                {b.name}
              </span>
              <span className="text-[#FF3B30] mx-6">/</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default BrandMarquee;
